<template>
  <ValidationProvider name="Saved query" slim vid="saved_query_id" rules="required">
    <template #default="{ errors }">
      <BaseFormGroup>
        <BaseFormLabel for="saved_query_id"> Saved Query </BaseFormLabel>
        <VSelect
          id="saved_query_id"
          v-model="savedQueryId"
          :options="options"
          label="name"
          :reduce="(savedQuery) => savedQuery.id"
          :disabled="disabled"
          class="vue-select custom-option"
        >
          <template #option="{ id, name }">
            <div class="group px-4 py-2">
              <p class="text-sm font-medium text-gray-900 group-hover:text-white">
                {{ name }}
              </p>
              <span class="text-gray-400 group-hover:text-indigo-200 text-xs">{{ id }}</span>
            </div>
          </template>
        </VSelect>
        <BaseFormInlineMessage v-if="errors.length" danger>
          {{ errors[0] }}
        </BaseFormInlineMessage>
      </BaseFormGroup>
    </template>
  </ValidationProvider>
</template>

<script>
import { accountContactSavedQueriesClient } from '@/api/clients';

export default {
  props: {
    accountId: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      default: null,
    },
    disabled: Boolean,
  },
  data() {
    return {
      options: [],
    };
  },
  computed: {
    savedQueryId: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  created() {
    this.fetchOptions();
  },
  methods: {
    async fetchOptions(query = {}) {
      try {
        const response = await accountContactSavedQueriesClient.list(this.accountId, query);

        this.setOptions(response.data);

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    setOptions(options) {
      this.options = options;
    },
  },
};
</script>
